export const loginSteps = {
    stepPhoneInput: "gatherPhoneNumber",
    stepSMSCodeInput: "gatherAndValidateSMSCode",
    stepLogin: "gatherLoginFields"
}